module.exports = __webpack_public_path__ + "img/erin-patterson9.af827678.png";